// Shared constants across the application

export const MAX_ESIM_COUNT = 10;

